var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00033 1.16602C3.79199 1.16602 1.16699 3.79102 1.16699 6.99935C1.16699 10.2077 3.79199 12.8327 7.00033 12.8327C10.2087 12.8327 12.8337 10.2077 12.8337 6.99935C12.8337 3.79102 10.2087 1.16602 7.00033 1.16602ZM7.00033 11.666C4.43366 11.666 2.33366 9.56602 2.33366 6.99935C2.33366 4.43268 4.43366 2.33268 7.00033 2.33268C9.56699 2.33268 11.667 4.43268 11.667 6.99935C11.667 9.56602 9.56699 11.666 7.00033 11.666Z",
    fill: "#19CC46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92467 5.425L6.41634 7.93333L5.07467 6.59167C4.84134 6.35833 4.49134 6.35833 4.25801 6.59167C4.02467 6.825 4.02467 7.175 4.25801 7.40833L6.00801 9.15833C6.12467 9.275 6.29967 9.33333 6.41634 9.33333C6.53301 9.33333 6.70801 9.275 6.82467 9.15833L9.74134 6.24167C9.97467 6.00833 9.97467 5.65833 9.74134 5.425C9.50801 5.19167 9.15801 5.19167 8.92467 5.425Z",
    fill: "#19CC46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.49d6a1259436910ab7721e91c3b78574.svg";
export { ForwardRef as ReactComponent };